<vex-page-layout class="h-screen flex flex-col">
  <div class="container sticky top-0 z-10">
    <div class="container h-64"> <!-- Set map height -->
    <div id="map" class="map-section"></div>
    <!-- <div class="map-container">
      <google-map height="500px" width="100%">
        <map-directions-renderer
          [directions]="directions"
          [options]="directionsRendererOptions">
        </map-directions-renderer>
      </google-map>
    </div> -->
    
    </div>
  </div>

  <vex-page-layout-content class="flex-1 overflow-y-auto">
  <!-- Bottom Section: Map -->
  
    <!-- Top Section: Vehicle Table -->
        <!-- Search Bar -->
      <!-- <mat-form-field appearance="outline" class="search-bar">
        <mat-label>{{'SEARCH.TEXT' | translate}}</mat-label>
        <input
          matInput
          (keyup)="applyFilter($event)"
          placeholder="Search by name or plate Number"
        />
      </mat-form-field> -->

      <div class="card">
        <!-- <mat-tab-group (selectedTabChange)="onLinkClick($event)" style="margin-top: 10px;">
            <mat-tab [label]="">
              
            </mat-tab>
            
          </mat-tab-group> -->
  
        <div class="bg-app-bar px-6 h-16 border-b flex items-center">
          <h2 class="title my-0 ltr:pr-4 rtl:pl-4 ltr:mr-4 rtl:ml-4 ltr:border-r rtl:border-l hidden sm:block flex-none">
              
            <button (click)="toggleTables(true)">{{"VEHICLES.TEXT" | translate}}</button>
            
          </h2>
          <h2 class="title my-0 ltr:pr-4 rtl:pl-4 ltr:mr-4 rtl:ml-4 ltr:border-r rtl:border-l hidden sm:block flex-none">
              
            <button (click)="toggleTables(false)">{{"LOADING-ORDER.TEXT"|translate}}</button>
            
          </h2>
          <!-- <div class="bg-foreground rounded-full border px-4 max-w-[300px] flex-auto flex items-center border border-gray-300">
                
              </div> -->
  
          <div
            class="rounded border border-black px-4 flex-auto flex items-center mat-table-search-input"
          >
            <mat-icon
              class="icon-sm text-secondary"
              svgIcon="mat:search"
            ></mat-icon>
            <input
              [formControl]="searchCtrl"
              class="px-4 py-2 border-0 outline-none w-full bg-transparent"
              [placeholder]="'SEARCH.TEXT' | translate"
              type="search"
            />
          </div>
  
          <span class="flex-1"></span>
          <span class="flex-1"></span>
          <span class="flex-1"></span>
  
          <button
            [matMenuTriggerFor]="columnFilterMenu"
            class="ml-4 flex-col"
            mat-icon-button
            [matTooltip]="'FILTER_COLUMNS.TEXT' | translate"
            type="button"
          >
            <mat-icon svgIcon="mat:filter_list"></mat-icon>
          </button>
        </div>
  
        <mat-progress-bar
          mode="indeterminate"
          *ngIf="isLoading"
        ></mat-progress-bar>

        <div class="table-container">
          <table *ngIf="this.isVehicleSelected"  @stagger
        [dataSource]="dataSource"
        class="mat-elevation-z8 mat-table-fixed"
        mat-table
        matSort>
            <!-- Vehicle Name Column -->
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef class="text-center">{{"VEHICLE.TEXT" | translate}}</th>
              <td mat-cell *matCellDef="let vehicle" class="text-center">{{ vehicle.name }}</td>
            </ng-container>
      
            <!-- Speed Column -->
            <ng-container matColumnDef="plateNumber">
              <th mat-header-cell *matHeaderCellDef class="text-center">{{"PLAT_NUMBER.TEXT" | translate}}</th>
              <td mat-cell *matCellDef="let vehicle" class="text-center">{{ vehicle.platNumber }}</td>
            </ng-container>
      
            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef class="text-center">{{"ACTION.TEXT" | translate}}</th>
              <td mat-cell *matCellDef="let vehicle" class="text-center">
                <button id="btnTrack" mat-button color="primary" (click)="focusVehicle(vehicle)">
                    <mat-icon class="icon-sm text-secondary" svgIcon="mat:location_on"></mat-icon>
                  Track
                </button>
              </td>
            </ng-container>
      
            <!-- Table Header and Row Definitions -->
            <tr *matHeaderRowDef="visibleColumns" mat-header-row></tr>
            <tr
              *matRowDef="let row; columns: visibleColumns"
              class="hover:bg-hover trans-ease-out cursor-pointer"
              mat-row></tr>
          </table>

          <table *ngIf="this.isOrdersSelected"  @stagger
        [dataSource]="dataSourceOrders"
        class="mat-elevation-z8 mat-table-fixed"
        mat-table
        matSort>

                    <!-- code Column -->
                    <ng-container matColumnDef="orderNumber">
                      <th mat-header-cell *matHeaderCellDef class="text-center">{{"ORDER_NO.TEXT"|translate}}</th>
                      <td mat-cell *matCellDef="let order" class="text-center">{{ order.orderNumber }}</td>
                    </ng-container>

            <!-- Vehicle Name Column -->
            <ng-container matColumnDef="customerName">
              <th mat-header-cell *matHeaderCellDef class="text-center">{{"CUSTOMERNAME.TEXT"|translate}}</th>
              <td mat-cell *matCellDef="let order" class="text-center">{{ order.customerName }}</td>
            </ng-container>
    

            <!-- destination Column -->
            <ng-container matColumnDef="customerAddress">
              <th mat-header-cell *matHeaderCellDef class="text-center">{{"CUSTOMER_ADDRESS.TEXT"|translate}}</th>
              <td mat-cell *matCellDef="let order" class="text-center">{{ order.customerAddressName }}</td>
            </ng-container>
      
            <!-- destination Column -->
            <ng-container matColumnDef="driverName">
              <th mat-header-cell *matHeaderCellDef class="text-center">{{"DRIVER_NAME.TEXT"|translate}}</th>
              <td mat-cell *matCellDef="let order" class="text-center">{{ order.driverName }}</td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef class="text-center">{{"ACTION.TEXT" | translate}}</th>
              <td mat-cell *matCellDef="let order" class="text-center">
                <button id="btnTrack" mat-button color="primary" (click)="focusVehicle(order)">
                    <mat-icon class="icon-sm text-secondary" svgIcon="mat:location_on"></mat-icon>
                  Track
                </button>
              </td>
            </ng-container>
      
          <!-- Table Header and Row Definitions -->
          <tr *matHeaderRowDef="visibleOrdersColumns" mat-header-row></tr>
          <tr
            *matRowDef="let row; columns: visibleOrdersColumns"
            class="hover:bg-hover trans-ease-out cursor-pointer"
            mat-row></tr>
          </table>
        </div>
        <!-- <mat-paginator
          [pageSizeOptions]="pageSizeOptions"
          [pageSize]="pageSize"
          [length]="totalRows"
          [pageIndex]="currentPage"
          (page)="pageChanged($event)"
          class="sticky left-0"
        >
        </mat-paginator> -->
      </div>
      <!-- <div class="table-wrapper">
        <table  @stagger
        [dataSource]="dataSource"
        class="mat-elevation-z8 mat-table-fixed"
        mat-table
        matSort>
            Vehicle Name Column 
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef> Vehicle </th>
              <td mat-cell *matCellDef="let vehicle">{{ vehicle.name }}</td>
            </ng-container>
      
            Speed Column 
            <ng-container matColumnDef="speed">
              <th mat-header-cell *matHeaderCellDef> Plate Number </th>
              <td mat-cell *matCellDef="let vehicle">{{ vehicle.PlateNumber }}</td>
            </ng-container>
      
             Actions Column 
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef> Actions </th>
              <td mat-cell *matCellDef="let vehicle">
                <button id="btnTrack" mat-button color="primary" (click)="focusVehicle(vehicle)">
                    <mat-icon class="icon-sm text-secondary" svgIcon="mat:location_on"></mat-icon>
                  Track
                </button>
              </td>
            </ng-container>
      
             Table Header and Row Definitions 
            <tr mat-header-row *matHeaderRowDef="['name', 'speed', 'actions']"></tr>
            <tr mat-row *matRowDef="let row; columns: ['name', 'speed', 'actions'];"></tr>
          </table>
      </div> -->

      
   
  
    
</vex-page-layout-content>
</vex-page-layout>  

<div [ngClass]="{'rtl': isRtl}">
  <mat-menu #columnFilterMenu="matMenu" xPosition="before" yPosition="below">
    <div class="scroll-container">
      <ng-container *ngIf="isVehicleSelected || isOrdersSelected">
        <button 
          (click)="toggleColumnVisibility(column, $event)"
          *ngFor="let column of (isVehicleSelected ? columns : ordersColumns)"
          class="checkbox-item mat-menu-item"
        >
          <mat-checkbox
            (click)="$event.stopPropagation()"
            [(ngModel)]="column.visible"
            color="primary"
            [aria-label]="column.label | translate"
          >
            {{ column.label | translate }}
          </mat-checkbox>
        </button>
      </ng-container>
    </div>
  </mat-menu>
</div>
